module.exports = __webpack_public_path__ + "static/media/digital.a6ba96bb.png";